import React, {useEffect,useState} from 'react'
import { connect } from 'react-redux';
import Footer from '../../components/footer/Footer';
import Header from '../../components/header/Header';
import MenuBar from '../../components/menu-bar/MenuBar';
import {
	UpdateCartCount,
	UpdateCartAmount
} from "../../redux/actions/postActions";
import { KMTracking, campaignRecord } from '../../components/Tracking/KMTracking';
import { List } from 'react-content-loader'
import { WebApiCalls } from "../../webApiCalls/webApiCalls";
import {Link} from 'react-router-dom'

const MyListLoader = () => <List/>
function Blog(props) {
	const [date, setDate] = useState('16 June 2020')
	const [description, setDescription] = useState("You might be missing your gym workouts these days,but did you know you can get an effective workout from home with just a few household items? In fact, adding odd-shaped items to your workout mimic the unpredictable movements we need to perform in our daily lives. ")
	const [description2, setDescription2] = useState("Have you ever picked up a heavy box or tried to lift it onto a shelf above, and felt a twinge in your lower back or shoulder? Although we may know how to perform these tasks, our bodies are often not strong or mobile enough to execute the movement without injuring ourselves. This could be due to poor posture, lack of flexibility and strength around our joints, or both.")
	const [thumbnail, setThumbnail] = useState('')
	const [shareUrl, setShareUrl] = useState('')
	const [datePost, setDatePost] = useState('')
	const [title, setTitle] = useState('')
	const [content, setContent] = useState('')
    const [is_loading, setIsLoading] = useState(false)

	let thumbnailUrl:any = ''

	useEffect(()=>{
		getBlogs();
        props.location.search && campaignRecord(props.location.search, props.location.pathname)
        if(props?.history?.location){
            window.scrollTo(0,0)
        }
    }, [])
	const tracker = async (eventName, _kmprops) => {
		await KMTracking(eventName, _kmprops)
	}
	const getBlogs = async () => {
        setIsLoading(true)
        const articleID = props?.match?.params?.blogID
        let articleItems:any = [];
        let deeplink_gen_url:any = undefined
        await new WebApiCalls().getArticleDetail(articleID)
            .then(result => {
                if (result && result.data && result.data && result.data) {
                    articleItems = result?.data?.items;
                    thumbnailUrl = articleItems[0].thumbnail;
					setThumbnail(articleItems[0].thumbnail)
					setTitle(articleItems[0].title )
                    let kmViewedProductProps = { "Blog article title": articleItems[0].title }
                    if (kmViewedProductProps['Blog article title'] !== '') {
                        tracker("viewedblogarticle", kmViewedProductProps);
                    }
					setDatePost(articleItems[0].summary ? articleItems[0].summary : "" )
                    const coloredContent = articleItems[0].content.replace("<body>", "<body bgcolor='#eaeaea'>");
					setContent(coloredContent)
                    deeplink_gen_url = "https://frxapp.page.link/?apn=com.frasersexperience.app&afl=https://play.google.com/store/apps/details?id=com.frasersexperience.app&ibi=com.frasersrewards.app&ifl=https://itunes.apple.com/pk/app/frasers-experience/id1441727505?mt=8&ofl=" + articleItems[0].url.replace(/&/g, "%26") + "&link=https://frxapp.page.link/articleDetails_";
					setShareUrl(deeplink_gen_url + articleID)
                }
            })
            .catch((error) => {
            })
            setIsLoading(false)
    }
	const onShare = () => {
        // if (window.ReactNativeWebView) {
            const data = {
                thumbnailUrl: thumbnail,
                title: "Frasers Experience - " + title,
                message: "Frasers Experience - " + title + " " + shareUrl,
                // url: 'data:' + mimeType + ';base64,' + base64Data,
                subject: "Frasers Experience - " + title,
                page: 'blogView',
                name: 'shareBlog'
            // };
            // window.ReactNativeWebView.postMessage(JSON.stringify(data));
        }
    }
	const renderBlogName = () => {
        return (
            <div style={{ textAlign: "center", textAlignLast: "center" }}>
                <h1 style={{ marginTop: 3, fontSize: 18, marginLeft: '8%', marginRight: '8%' }} className="headings-black-mid">{title}</h1>
                <h1 style={{ marginTop: 5, fontSize: 16 }} className="headings-gray-mid">{datePost}</h1>
                {/* <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <div
                        style={{
                            alignSelf: 'center',
                            paddingTop: 20,
                            paddingBottom: 10,
                            flexDirection: 'row',
                            display: 'flex'
                        }}
                        onClick={() => {
                            onShare()
                        }}>
                        <img
                            style={{
                                width: '20%',
                                height: '20%',
                            }}
                            alt="img"
                            src={require('../../images/iconshare.png')}

                        />
                        <div style={{
                            color: 'red',
                            fontSize: 16,
                            marginLeft: '5%',
                            fontFamily: "BurlingamePro-CondBold"
                        }}>
                            Share
                    </div>
                    </div>
                </div> */}
            </div>
        )
    }
    return (
    <div>
		<div className="viewport"></div>

		{/* /container */}
		<div className="container">

			{/* header */}
			<Header props={props}/>
			{/* /header */}

		
			<MenuBar props={props} categoriesArray={props?.allCategories ? props?.allCategories : []}/>

            {/* /content */}
		{is_loading ? <MyListLoader /> :
            <div className="content">

			{/* breadcrumb-back */}
			<div className="breadcrumb-back">
				
				{/* breadcrumb */}
				<div className="breadcrumb">
					<Link to="/">Home</Link>
					{/* <a href="/">Blog</a> */}
					<Link to="/">{title}</Link>
				</div>
				{/* /breadcrumb */}

				<a  onClick={() => props?.history?.goBack()} className="backbtn">BACK</a>

			</div>
			{/* /breadcrumb-back */}

			{/* detail */}
			{/* {renderBlogName()} */}

			
			<div className="detail blog">
				
			        <img style={{width: '100%'}} alt="" src={thumbnail} /><br/>
			        
			        <h4>
			            {title}</h4>
				<div className="two-col nostack" style={{justifyContent: 'center', display: 'block'}}>
			        <div className="row" style={{flexWrap: 'nowrap'}}>
					<div style={{paddingLeft:'13.5px',paddingRight:'13.5px'}}
                    dangerouslySetInnerHTML={{
                            __html: content
                }}></div>
			        </div>
			    </div>
			
			 
			</div>
			{/* <div
                    dangerouslySetInnerHTML={{
                            __html: content
                }}></div> */}

		</div>}
		{/* /content*/}

			</div>

		<Footer props={props} categoriesArray={props?.allCategories ? props?.allCategories : []}/>
		
		
        </div>
    )
}
const mapStateToProps = (state) => {
	const { cart_count,allCategories } = state.UserReducer
	return { cart_count,allCategories }
};
const actions = {
	UpdateCartCount,
	UpdateCartAmount
};
export default connect(mapStateToProps, actions)(Blog);